import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  const token = url.startsWith("/owner")
    ? localStorage.getItem("bh_owner_token")
    : url.startsWith("/uploads")
    ? localStorage.getItem("bh_owner_token") || localStorage.getItem("bh_admin_token")
    : localStorage.getItem("bh_admin_token") || localStorage.getItem("bh_owner_token");
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtLocation = (l) =>
  [l?.address?.city, l?.address?.state].filter(Boolean).join(", ");

export const ACTION_META = {
  website: { label: "Visit Website" },
  order_online: { label: "Order Online" },
  menu: { label: "View Menu" },
  book: { label: "Book Appointment" },
  reservation: { label: "Make Reservation" },
  quote: { label: "Get Quote" },
  shop: { label: "Shop Online" },
};
